import produce from 'immer';
import { ISubscriptionPlanInitialState, types } from './types';
import { restoreInitialState } from '../../utils/AppUtils';
import { types as AuthTypes } from '../authentication/types';

const initialState: ISubscriptionPlanInitialState = {
    subscriptionPlans: [],
    fetchingSubscriptionPlans: false,
    fetchingSubscriptionPlansError: null,
    loggedInUserPlan: undefined,
    fetchingLoggedInUserPlan: false,
    fetchingLoggedInUserPlanError: null,
    updatingUserPlan: false,
    updatingUserPlanError: null,
    subscribing: false,
    subscribeError: null,
    subscription: undefined,
};

const reducer = (state = initialState, action: any) => {
    const { type, payload } = action;

    switch (type) {
        case types.SUBSCRIBE:
            return produce(state, (draftState: typeof initialState) => {
                draftState.subscribing = true;
            });
        case types.SUBSCRIBE_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.subscribing = false;
                draftState.subscription = payload;
            });
        case types.SUBSCRIBE_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.subscribing = false;
                draftState.subscribeError = payload;
            });
        case types.GET_SUBSCRIPTION_PLANS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingSubscriptionPlans = true;
            });
        case types.GET_SUBSCRIPTION_PLANS_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingSubscriptionPlans = false;
                draftState.subscriptionPlans = payload;
            });
        case types.GET_SUBSCRIPTION_PLANS_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingSubscriptionPlans = false;
                draftState.fetchingSubscriptionPlansError = payload;
            });
        case types.SET_SUBSCRIPTION:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingLoggedInUserPlan = true;
            });
        case types.SET_SUBSCRIPTION_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingLoggedInUserPlan = false;
                const parsedSubscription = payload;
                draftState.subscription = parsedSubscription;
            });
        case types.SET_SUBSCRIPTION_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingLoggedInUserPlan = false;
                draftState.fetchingLoggedInUserPlanError = payload;
            });
        case types.UPDATE_SUBSCRIPTION:
            return produce(state, (draftState: typeof initialState) => {
                draftState.updatingUserPlan = true;
            });
        case types.UPDATE_SUBSCRIPTION_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.updatingUserPlan = false;
                draftState.subscription = payload;
            });
        case types.UPDATE_SUBSCRIPTION_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.updatingUserPlan = false;
                draftState.updatingUserPlanError = payload;
            });
        case types.RESET_SUBSCRIPTION_DATA:
        case AuthTypes.LOGOUT:
            return restoreInitialState(state, initialState);
        default:
            return state;
    }
};

export { reducer };
